module.exports = __webpack_public_path__ + "img/saml.047a1a00.svg";